module.exports = __webpack_public_path__ + "static/media/face_landmark_demo.06378403.png";